import React from 'react';
import PropTypes from 'prop-types';

/**
 * The AddonsHeader component.
 */
class AddonsHeader extends React.Component {
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {nextStep, description} = this.props;

    return (
      <div>
        <h5 className="text-uppercase font-weight-bold">
          OPTIONAL ADD-ONS
        </h5>
        <div className="d-flex justify-content-between mt-3">
          <div>
            {description}<br />
            Questions? Email our team to schedule a demo: <a href="mailto:info@projectcontent.com">info@projectcontent.com</a>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary text-light"
              onClick={nextStep}
            >
              Skip →
            </button>
          </div>
        </div>
      </div>
    );
  }
}

AddonsHeader.propTypes = {
  description: PropTypes.string,
  nextStep: PropTypes.func,
  prevStep: PropTypes.func,
};

export default AddonsHeader;
